import React from 'react'

const PriceBanner = ({ className = '' }) => (
  <div
    className={`rounded-xl bg-gradient-to-r from-emerald-500 via-yellow-400 to-teal-500 px-4 py-3.5 text-center shadow-lg border border-emerald-400/20 hover:scale-[1.01] transition-all duration-300 cursor-default ${className}`}
  >
    <p className="text-lg sm:text-xl font-black tracking-wide text-white drop-shadow-sm uppercase flex items-center justify-center gap-2">
      SPECIAL CLINIC DEAL: AS LOW AS $1.03 EACH
    </p>
  </div>
)

export default PriceBanner
